//#region src/js/cart-remove-button.js
var CartRemoveButton = class extends HTMLElement {
	connectedCallback() {
		this.addEventListener("click", (event) => {
			event.preventDefault();
			(this.closest("cart-items") || this.closest("cart-drawer-items")).updateQuantity(this.dataset.index, 0);
		});
	}
};
customElements.define("cart-remove-button", CartRemoveButton);
//#endregion
